import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-accounts-view',
  templateUrl: './accounts-view.component.html',
  styleUrls: ['./accounts-view.component.scss']
})
export class AccountsViewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
